module.exports = __webpack_public_path__ + "img/AT0000002415634.b51d3c25.png";